import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import MenuMobileBar from "./MenuMobileBar";

interface ButtonProps {
  title: string;
  action: () => void;
  icon: JSX.Element;
  disabled?: Boolean;
}

interface Props {
  buttons: ButtonProps[];
  title: string;
}

export function MobileBar({ title, buttons }: Props) {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: "rgba(140, 150, 169, 0.95)",
        backdropFilter: "blur(20px)",
        borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
        boxShadow: "0 2px 12px rgba(140, 150, 169, 0.2)",
      }}
    >
      <Toolbar sx={{ minHeight: "56px !important" }}>
        <Typography
          variant="subtitle1"
          component="div"
          sx={{
            flexGrow: 1,
            color: "white",
            fontWeight: 600,
            fontSize: "1.1rem",
          }}
        >
          {title}
        </Typography>
        <MenuMobileBar buttons={buttons} />
      </Toolbar>
    </AppBar>
  );
}
